import React from 'react';
import { ErrorScreenProps, ErrorType, ScreenConfig } from '../schema/ErrorScreen.types';
import { getOwaMiniCommonStrings, OwaMiniCommonStrings } from 'owa-strings/owa-mini-common-strings';
import { hardRefresh } from '../utils/hardRefresh';

const styles = require('./ErrorScreen.scss');

interface BaseErrorScreenProps extends ErrorScreenProps {
    errorType: ErrorType;
}

/**
 * Functional Component to display the base error screen
 * @param props Error Screen Props
 */
const BaseErrorScreen = (props: BaseErrorScreenProps): JSX.Element => {
    const strings = getOwaMiniCommonStrings();
    const { errorType, onRetry, screenConfig } = props;

    const onClickRetry = () => {
        (onRetry || hardRefresh)();
    };

    const secondaryTitle: string = getSecondaryTitleString(errorType, screenConfig);

    return (
        <>
            <PrimaryTitle errorType={errorType} strings={strings} />
            <SecondaryTitle secondaryTitle={secondaryTitle} />
            <RetryButton onClickRetry={onClickRetry} strings={strings} />
        </>
    );
};

function PrimaryTitle({
    errorType,
    strings,
}: {
    errorType: ErrorType;
    strings: OwaMiniCommonStrings;
}) {
    return (
        <div className={styles.primaryTitle}>
            {errorType === ErrorType.Network
                ? strings.errorBoundaryNetworkErrorPrimaryHeader
                : strings.errorBoundaryHeader}
        </div>
    );
}

function SecondaryTitle({ secondaryTitle }: { secondaryTitle: string }) {
    return <div className={styles.secondaryTitle}>{secondaryTitle}</div>;
}

function RetryButton({
    onClickRetry,
    strings,
}: {
    onClickRetry: () => void;
    strings: OwaMiniCommonStrings;
}) {
    return (
        <div role="button" className={styles.retryButton} onClick={onClickRetry}>
            {strings.retryButton}
        </div>
    );
}

function getSecondaryTitleString(errorType: ErrorType, screenConfig: ScreenConfig): string {
    const strings = getOwaMiniCommonStrings();

    if (screenConfig && screenConfig.title) {
        return screenConfig.title;
    }

    if (errorType === ErrorType.Network) {
        return strings.errorBoundaryNetworkErrorSecondaryHeader;
    }

    return strings.genericErrorSecondaryHeader;
}

export { BaseErrorScreen };
